import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../../components/Layout';

class HotelManagerHome extends React.Component {

  render() {
    return (
      <div className="content-tours">
        <div className="panel">
          <h1>Welcome to Use Catch!</h1>
          <div>Catch allows you to find more business for your hotel properties.</div>
          <div><a href="mailto:info@usecatch.com">Contact us</a> if you need access to a group travel or travel agency?</div>
        </div>
      </div>
    );
  }
}

export default HotelManagerHome;



// WEBPACK FOOTER //
// src/routes/home/components/HotelManagerHome.js